module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "reddit.b42bab17.svg";